/**
 * Created by razial on 09.04.2024.
 */

cleverapps.EventEmitter = function () {
    this.bindings = {};
};

cleverapps.EventEmitter.prototype.once = function (eventName, callback, target) {
    const handler = this.on(eventName, (...args) => {
        handler.clear();
        callback.call(this, ...args);
    }, target);

    return handler;
};

cleverapps.EventEmitter.prototype.on = function (eventName, callback, target) {
    if (!this.bindings[eventName]) {
        this.bindings[eventName] = [];
    }
    this.bindings[eventName].push(callback);
    const handler = {
        clear: () => {
            if (this.bindings[eventName]) {
                const index = this.bindings[eventName].indexOf(callback);
                if (index >= 0) {
                    this.bindings[eventName].splice(index, 1);
                }
            }
        }
    };

    addCleaner(target, () => handler.clear());

    return handler;
};

cleverapps.EventEmitter.prototype.off = function (eventName) {
    this.bindings[eventName] = undefined;
};

cleverapps.EventEmitter.prototype.purge = function () {
    this.bindings = {};
};

cleverapps.EventEmitter.prototype.trigger = function (...args) {
    if (this.proxyBus) {
        this.proxyBus.trigger.call(this.proxyBus, ...args);
    }

    const eventName = args.shift();
    if (this.bindings[eventName]) {
        this.bindings[eventName].slice().forEach(function (callback) {
            callback.apply(this, args);
        });
    }
};

cleverapps.EventEmitter.prototype.setProxy = function (proxyBus) {
    this.proxyBus = proxyBus;
};

const addCleaner = function (target, cleaner) {
    if (typeof target === "object") {
        if (!target._cleaners) {
            target._cleaners = [];
        }
        target._cleaners.push(cleaner);
    }
};

// eslint-disable-next-line no-unused-vars
const runCleaners = function (target) {
    if (target._cleaners) {
        target._cleaners.forEach(cleverapps.callFunc);
        delete target._cleaners;
    }
};
